import { LESSONS } from '../actions/lessons';

const defaultState = {
  list: [],
  total: 0,
  details: {},
};

export default (state = defaultState, { type, ...action }) => {
  switch (type) {
    case LESSONS.LIST:
      return { ...state, list: [], total: 0 };

    case LESSONS.LIST_DONE:
      return { ...state, list: action.list, total: action.total };

    case LESSONS.LIST_FAILED:
      return { ...state, list: [], total: 0 };

    case LESSONS.LOAD_BY_ID_DONE:
      return { ...state, details: { [action.item.id]: action.item } };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/lessons.js